export default __webpack_public_path__ + "static/image02-2a24d3226e496511957178a315341512.png";